import { IRemoteData } from '../../../interfaces';

export function isLoading(widgetData: IRemoteData[]): boolean {
    return hasPropertyTrue(widgetData, 'loading');
}

export function isError(widgetData: IRemoteData[]): boolean {
    return hasPropertyTrue(widgetData, 'error');
}

export function hasPropertyTrue(widgetData: IRemoteData[], property: string): boolean {
    return widgetData.reduce((curr: boolean, entry: IRemoteData) => {
        return curr || (entry && entry[property] === true);
    }, false);
}

export function hasProperty(widgetData: IRemoteData[], property: string): boolean {
    return widgetData.reduce((curr: boolean, entry: IRemoteData) => {
        return curr || (entry && entry[property]);
    }, false);
}

export function getErrorMessage(widgetData: IRemoteData[]): string {
    return widgetData.reduce((curr: string, entry: IRemoteData) => {
        return curr || entry.data.message;
    }, false);
}

export interface IError {
    widgetName: string;
    message: string;
    error?: {
        status?: number
        method?: 'POST' | 'GET',
        url?: string
    },
}

export function getErrorObject(widgetName: string, widgetData: IRemoteData[]): IError {
    const entry = widgetData.find((entry: IRemoteData) => entry && entry.data && (entry.data.message !== undefined));
    return entry ? { widgetName, message: entry.data.message, error: (entry.data.response || {}).error } : { widgetName, message: 'unknown error'};
}

export default {
    isLoading,
    isError,
    hasPropertyTrue,
    getErrorMessage,
};



// WEBPACK FOOTER //
// ./src/components/widget/util/RemoteDataUtil.ts